import {needAuth} from "../instance/Instance";
import {getPages} from "../../components/commonmethod/CommonMethod";

async function getDepreciationList(search, pageable) {
    pageable.sort = [pageable.sort, "id"];
    try {
        return await needAuth.post('/asset/depreciation?' + getPages(pageable), search);
    } catch (error) {
        if (error?.response?.data) {
            return error.response;
        }
        return error;
    }
}

async function removeDepreciations(ids) {
    return await needAuth.put('/asset/depreciation/delete', ids);
}

async function getDepreciation(id) {
    try{
        return  await needAuth.get('/asset/depreciation/'+id);
    }catch (error){
        return error;
    }
}

async function saveDepreciation(depreciation) {
    try {
        return await needAuth.post(`/asset/depreciation/create`, depreciation);
    } catch (error) {
        return error;
    }
}

async function updateDepreciation(data) {
    return await needAuth.put(`/asset/depreciation`, data);
}

async function getDepreciationByAsset(id) {
    try{
        return  await needAuth.get('/asset/depreciation/assetId/'+id);
    }catch (error){
        return error;
    }
}

export {getDepreciationList, removeDepreciations, saveDepreciation, getDepreciation, updateDepreciation, getDepreciationByAsset};